import React from 'react';
import { undoableDebugWait } from '../../stores/undo/operation/DebugWaitOp';

const DebugLine = ({
  lineLabel,
  failExecute,
  failUndo,
  failRedo
}) => {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, lineLabel), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => undoableDebugWait(2, false, failExecute, failUndo, failRedo)
  }, "2s non-blocking"), /*#__PURE__*/React.createElement("button", {
    onClick: () => undoableDebugWait(5, false, failExecute, failUndo, failRedo)
  }, "5s non-blocking")));
};

export const DebugWait = () => {
  return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(DebugLine, {
    lineLabel: "",
    failExecute: false,
    failUndo: false,
    failRedo: false
  }), /*#__PURE__*/React.createElement(DebugLine, {
    lineLabel: "Fail execute",
    failExecute: true,
    failUndo: false,
    failRedo: false
  }), /*#__PURE__*/React.createElement(DebugLine, {
    lineLabel: "Fail undo",
    failExecute: false,
    failUndo: true,
    failRedo: false
  }), /*#__PURE__*/React.createElement(DebugLine, {
    lineLabel: "Fail redo",
    failExecute: false,
    failUndo: false,
    failRedo: true
  })));
};